import { SELECTED_LAYOUT } from './actionTypes'

export const getSelectedLayout = (layout) => ({
  type: SELECTED_LAYOUT,
  payload: layout,
})
